module.exports = __webpack_public_path__ + "img/img2.fw.f9c3c73f.png";